import {
  GET_VARIAVEIS_GLOBAIS_INIT,
  GET_VARIAVEIS_GLOBAIS_SUCCESS,
  UPDATE_VARIAVEIS_GLOBAIS_INIT,
  UPDATE_VARIAVEIS_GLOBAIS_SUCCESS,
  ERROR_VARIAVEIS_GLOBAIS_MSG,
  CLEAR_FLAGS_VARIAVEIS_GLOBAIS
} from '../../actionTypes';

export const getVariaveisGlobaisInit = () => ({
  type: GET_VARIAVEIS_GLOBAIS_INIT,
  payload: {}
});

export const getVariaveisGlobaisSuccess = (data: any) => ({
  type: GET_VARIAVEIS_GLOBAIS_SUCCESS,
  payload: data
});

export const atualizaVariaveisGlobaisInit = (data: any) => ({
  type: UPDATE_VARIAVEIS_GLOBAIS_INIT,
  payload: data
});

export const atualizaVariaveisGlobaisSuccess = (data: any) => ({
  type: UPDATE_VARIAVEIS_GLOBAIS_SUCCESS,
  payload: data
});

export const errorVariaveisGlobaisMsg = (data: any) => ({
  type: ERROR_VARIAVEIS_GLOBAIS_MSG,
  payload: data
});

export const clearFlagsVariaveisGlobais = () => ({
  type: CLEAR_FLAGS_VARIAVEIS_GLOBAIS,
  payload: {}
});
